import mitt, { Emitter } from "mitt";
import { IGif, INiche } from "services/types";

type GifPlaybackEvent = {
  id: string;
  duration: number;
};

export type MenuShareEvent = {
  event: React.MouseEvent<HTMLButtonElement>;
  gif: IGif;
}

export type MoreMenuEvent = {
  event: React.MouseEvent<HTMLButtonElement>;
  gif: IGif;
  sourceId: string | null;
  fullscreen: boolean;
  hideGif: (id: string) => void;
};

export type NicheEditEvent = {
  niche?: INiche;
};

export type MainBusEvents = {
  gif_view: string;
  gif_playback: GifPlaybackEvent;
  gif_menu_open: MoreMenuEvent;
  gif_share_open: MenuShareEvent;
  niche_edit_open: NicheEditEvent;
};

type BusType = Emitter<MainBusEvents>;

export const mainBus: BusType = mitt<MainBusEvents>();
